import React from 'react';
import css from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <div className={css.content}>
      <p>Diese Datenschutzerklärung gilt für die von uns angebotene Website <a href="/" target="_blank" rel="noopener noreferrer">www.kitts.de</a> (nachfolgend
        „Website“) sowie unserer Plattform kitts (nachfolgend „Plattform“) und der dort zur Verfügung
        gestellten Angebote (nachfolgend „Dienste“). Mit der Plattform möchten wir Sammlern und
        Liebhabern1 von originalen Retro-/Secondhand-Fußballtrikots (nachfolgend „Trikots“) einen
        Marktplatz bieten, die Trikots zu entdecken, zu teilen, zu verkaufen oder zu kaufen.</p>
      <p>Der Schutz Ihrer Privatsphäre ist für uns sehr wichtig und eine Selbstverständlichkeit. Die
        gesetzlichen Vorgaben verlangen umfassende Transparenz über die Verarbeitung
        personenbezogener Daten. Nur wenn die Verarbeitung für Sie als betroffene Person
        nachvollziehbar ist, sind Sie ausreichend über den Sinn, Zweck und Umfang der Verarbeitung
        informiert. Nachstehend informieren wir Sie deshalb ausführlich und umfassend über den
        Umgang mit Ihren Daten und Ihre Rechte in Bezug auf Ihre personenbezogenen Daten, die von
        uns bei der Nutzung unserer Website und unserer Dienste verarbeitet werden.
        Personenbezogene Daten sind hierbei alle Daten, mit denen Sie persönlich identifiziert werden
        können.</p>
      <h3>1. Datenverantwortliche</h3>
      <h3>1.1. Name und Anschrift des Verantwortlichen</h3>
      <p>Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten auf der Website und
        Plattform sowie im Rahmen der Nutzung unserer dort angebotenen Dienste im Sinne von Art. 4
        Nr. 7 Datenschutzgrundverordnung (nachfolgend „DSGVO“) ist, soweit nicht in Ziff. 1.2.
        abweichend geregelt:</p>
      <p>kitts GmbH (nachfolgend „KITTS“ oder „wir“), <br />
        vertreten durch die Geschäftsführung, <br />
        Oberdorf 4, <br />
        D-54497 Morbach</p>
      <p>E-Mail: info@kitts.de</p>
      <h3>1.1. Gemeinsame Verantwortlichkeit</h3>
      <p>Im Zusammenhang mit dem Verkauf von Trikots über unsere Plattform legen wir und die als
        Verkäufer verifizierten Nutzer der Plattform die Zwecke und Mittel der nachstehend
        beschriebenen Datenverarbeitungen im Zusammenhang mit dem Verkauf von Trikots (vgl. Ziff.
        4.3.) gemeinsam fest. Wir und der jeweilige Verkäufer sind daher im Rahmen der mit einem
        Verkauf verbundenen Datenverarbeitungen gemeinsam für den Schutz Ihrer
        personenbezogenen Daten verantwortlich (Art. 26 DSGVO).</p>
      <p>Wir schließen mit jedem Verkäufer im Hinblick auf die gemeinsame Verantwortlichkeit einen
        Vertrag nach Art. 26 Abs. 1 DSGVO, der insbesondere die jeweiligen Pflichten nach Art. 13, 14
        sowie 15 bis 22 DSGVO regelt. Danach ist festgelegt, dass, auch wenn eine gemeinsame
        Verantwortlichkeit besteht, wir und der einzelne Verkäufer Ihnen gegenüber die
        datenschutzrechtlichen Pflichten entsprechend wie folgt erfüllen:</p>
      <ul>
        <li>Jeder Verantwortliche erfüllt den betroffenen Personen gegenüber selbstständig die
          entsprechenden Informationspflichten nach Art, 13, 14 DSGVO sowie ihre Betroffenenrechte
          gemäß Art. 15 bis 22 DSGVO.</li>
        <li>Wir und der Verkäufer informieren uns unverzüglich gegenseitig über geltend gemachte
          Rechte. Wir stellen einander sämtliche für die Beantwortung von Auskunftsersuchen
          notwendigen Informationen zur Verfügung.</li>
      </ul>
      <h3>2. Allgemeine Informationen zur Datenverarbeitung</h3>
      <h3>2.1. Art und Umfang der Verarbeitung von personenbezogenen Daten</h3>
      <p>Wir verarbeiten personenbezogene Daten nur, soweit dies gesetzlich zulässig ist und
        insbesondere für die Bereitstellung einer funktionsfähigen Website sowie unserer Dienste
        erforderlich ist.</p>
      <h3>2.2. Rechtsgrundlage für die Verarbeitung von personenbezogenen Daten</h3>
      <p>Soweit wir für Verarbeitungsvorgänge personenbezogener Daten Ihre Einwilligung einholen,
        dient Art. 6 Abs. 1 lit. a DSGVO als Rechtsgrundlage. Bei der Verarbeitung personenbezogener
        Daten, die für die Erfüllung eines Vertrages, dessen Vertragspartei Sie sind, erforderlich ist, dient
        Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur
        Durchführung vorvertraglicher Maßnahmen erforderlich sind. Soweit die Verarbeitung
        personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung, der unser Unternehmen
        unterliegt, erforderlich ist, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage. Für den Fall, dass
        Ihre lebenswichtigen Interessen oder die einer anderen natürlichen Person eine Verarbeitung von
        personenbezogenen Daten erforderlich machen, dient Art. 6 Abs. 1 lit. d DSGVO als
        Rechtsgrundlage.</p>
      <p>Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder
        eines Dritten erforderlich und überwiegen die Interessen, Ihre Grundrechte und Grundfreiheiten
        das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die
        Verarbeitung.</p>
      <h3>2.3. Löschung der Daten und Aufbewahrungsfrist</h3>
      <p>Die von uns für die nachfolgenden Zwecke beschriebenen Zwecke verarbeiteten
        personenbezogenen Daten werden grundsätzlich gelöscht oder durch technische Maßnahmen
        (z.B. Anonymisierung) geschützt/gesperrt, sobald der Zweck der Verarbeitung entfällt. Dies
        erfolgt auch dann, wenn eine vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine
        Erforderlichkeit zur weiteren Speicherung der personenbezogenen Daten für einen anderen
        Speicherzweck besteht. Sofern wir nicht gesetzlich zu einer längeren Speicherung (z.B. wegen
        steuer- oder handelsrechtlicher Aufbewahrungspflichten) oder einer Offenlegung gegenüber
        Dritten (insbesondere Strafverfolgungsbehörden) verpflichtet sind, hängt die Entscheidung,
        welche personenbezogenen Daten von uns verarbeitet werden, davon ab, welche Funktionen der
        Website oder kitts-Angebote Sie im Einzelfall nutzen.</p>
      <h3>2.4. Weitergabe / externe Links</h3>
      <p>Bitte beachten Sie, dass Sie über Links auf unserer Website zu anderen Internetseiten gelangen
        können, die nicht von uns, sondern von Dritten betrieben werden. Solche Links werden von uns
        entweder eindeutig gekennzeichnet oder sind durch einen Wechsel in der Adresszeile Ihres
        Browsers erkennbar. Sofern diese Websites nicht durch uns betrieben werden, sind wir für die
        Einhaltung der datenschutzrechtlichen Bestimmungen und einen sicheren Umgang mit Ihren
        personenbezogenen Daten auf diesen von Dritten betriebenen Internetseiten nicht
        verantwortlich.</p>
      <h3>3. Besuch und generelle Nutzung unserer Website</h3>
      <h3>3.1. Server-Logfiles</h3>
      <p>Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden
        Browser automatisch Informationen an die jeweiligen Server unserer Website gesendet. Diese
        Informationen werden temporär in einem Logfile (nachfolgend „Server-Logfile“) gespeichert.
        Folgende Informationen werden dabei erfasst und bis zur automatisierten Löschung gespeichert:</p>
      <ul>
        <li>um das letzte Oktett gekürzte IP-Adresse des anfragenden Rechners,</li>
        <li>Datum und Uhrzeit des Zugriffs,</li>
        <li>Name und URL der abgerufenen Datei,</li>
        <li>Website, von der aus der Zugriff erfolgt (Referrer-URL),</li>
        <li>verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie</li>
        <li>der Name Ihres Access-Providers.</li>
      </ul>
      <p>Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:</p>
      <ul>
        <li>Gewährleistung eines reibungslosen Verbindungsaufbaus zur Website,</li>
        <li>Gewährleistung einer komfortablen Nutzung unserer Website,</li>
        <li>Überprüfung und Gewährleistung der Systemsicherheit und -stabilität sowie</li>
        <li>zu weiteren administrativen Zwecken.</li>
      </ul>
      <p>Ihre IP-Adresse wird insbesondere zur Erkennung von Malware und Bots, zur retrospektiven
        Betrachtung und Analyse von Angriffen und unberechtigten Zugriffsversuchen und zum Blocken
        von IP-Adressen, die durch eine besonders hohe Aufrufdichte auf einen Inhalt zu einem hohen
        Load unserer Website führen, erhoben.</p>
      <p>Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes
        Interesse folgt aus vorgenannten Zwecken der Datenerhebung. In keinem Fall verwenden wir die
        erhobenen Daten zu dem Zweck, Rückschlüsse auf Ihre Person zu ziehen. Wir löschen diese Daten
        routinemäßig nach Ablauf von spätestens sechs (6) Monaten, spätestens ohnehin nach Wegfall
        des Zwecks der Verarbeitung. Wir führen diese personenbezogenen Daten nicht mit anderen
        Datenquellen zusammen. Eine Offenlegung findet nur statt, soweit dies zum Betrieb unserer
        Website im Hinblick auf Auftragsverarbeiter gemäß Artikel 28 DSGVO erforderlich ist, z.B. mit der
        Speicherung bei unserem Host-Provider. Wir behalten uns jedoch vor, die Server-Logfiles
        nachträglich zu überprüfen, wenn konkrete Anhaltspunkte für eine rechtswidrige bzw.
        systemwidrige Nutzung unserer Website vorliegen.</p>
      <p>Die Erhebung der Daten für die Bereitstellung der Website und die Speicherung der Daten in
        Logfiles ist für den Betrieb der Website unbedingt erforderlich (vgl. Art. 21 Abs. 1 DSGVO). Folglich
        gibt es für den Nutzer keine Möglichkeit des Widerspruchs. Ein Besuch unserer Website ist ohne
        die o.g. Datenverarbeitung nicht möglich.</p>
      <h3>3.2. Kontaktanfrage</h3>
      <p>Wenn Sie uns an eine auf der Website genannte Kontaktmöglichkeit eine E-Mail schreiben oder
        sich über einen sonstigen Kommunikationsweg an uns wenden, werden die von Ihnen
        angegebenen personenbezogenen Daten von uns verarbeitet. In diesem Fall werden die mit der
        E-Mail bzw. der Nachricht übermittelten und von Ihnen angegebenen personenbezogenen Daten
        (Name, E-Mailadresse, Ihre IP-Adresse sowie Datum und Uhrzeit der Kontaktanfrage) gespeichert.</p>
      <p>Diese Informationen werden von Ihrem E-Mail-Client oder dem sonstigen Kommunikationsweg
        übermittelt und in unseren IT-Systemen verarbeitet. Die Verarbeitung dieser personenbezogenen
        Daten ist notwendig für die Beantwortung Ihrer Anfrage.</p>
      <p>Rechtsgrundlage für diese Datenverarbeitung ist unser berechtigtes Interesse an der
        Beantwortung Ihrer Anfrage im Sinne des Art. 6 Abs. 1 lit. f DSGVO. Kommt es nach der
        Kontaktaufnahme durch Sie zu einem Vertragsabschluss mit uns in Bezug auf die Nutzung der
        Website, stützt sich die weitere Verarbeitung Ihrer personenbezogenen Daten auf die
        Rechtsgrundlage des Art. 6 Abs. 1 lit. b DSGVO.</p>
      <p>Die personenbezogenen Daten werden so lange verarbeitet, wie dies zur Beantwortung Ihrer
        Anfrage erforderlich ist. Sollte Ihre Anfrage zu einem späteren Vertragsabschluss führen, findet
        eine Verarbeitung statt, solange dies zur Durchführung vorvertraglicher Maßnahmen oder zur
        Erfüllung des Vertrags erforderlich ist. Kommt kein Vertrag zustande, werden die
        personenbezogenen Daten routinemäßig spätestens alle sechs (6) Monate gelöscht. Wir führen
        Ihre personenbezogenen Daten nicht mit anderen Datenquellen zusammen. Eine Offenlegung
        Ihrer personenbezogenen Daten gegenüber Dritten findet nicht statt.</p>
      <p>Die Bereitstellung Ihrer personenbezogenen Daten im Zusammenhang mit dem Versand einer E-
        Mail oder der Kontaktaufnahme über einen sonstigen Kommunikationskanal an uns erfolgt
        freiwillig, bitte geben Sie daher nur die aus Ihrer Sicht für die Beantwortung Ihrer Anfrage
        erforderlichen personenbezogenen Daten an.</p>
      <h3>3.3 Newsletter</h3>
      <p>Wenn Sie unseren Newsletter – über eine Anmeldung auf unserer Website oder sonstige
        Bezugsmöglichkeiten – beziehen möchten, verarbeiten wir Ihre E-Mail-Adresse sowie ggf. Ihren
        Namen, sofern Sie diesen auf freiwilliger Basis angeben. Die freiwilligen Angaben nutzen wir um
        unsere Beziehung zu Ihnen als Newsletter-Abonnent permanent zu verbessern.</p>
      <p>Nach der Registrierung erhalten Sie zunächst eine E-Mail, die Sie über einen dort enthaltenen Link
        bestätigen müssen (Double-Opt-In). Dieses Verfahren dient der Überprüfung, ob der Inhaber der
        bei der Registrierung angegebenen E-Mail-Adresse in den Erhalt des Newsletters eingewilligt hat.
        Das Datum und die Uhrzeit einer Bestätigung werden von uns gespeichert.</p>
      <p>Wir verwenden Ihre personenbezogenen Daten ausschließlich für die Durchführung des Double-
        Opt-in-Verfahrens sowie den Versand der angeforderten, ggf. auch werblichen und/oder Partner-
        Informationen und geben diese nicht an Dritte weiter.</p>
      <p>Die Verarbeitung Ihrer Daten erfolgt zur Umsetzung des Double-Opt-In-Verfahrens zur Erfüllung
        unserer rechtlichen Verpflichtung nach Art. 6 Abs. 1 S. 1 lit. c DSGVO, für den Versand des
        Newsletters ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO). Die
        erteilte Einwilligung zur Speicherung der Daten sowie deren Nutzung zum Versand des
        Newsletters können Sie jederzeit widerrufen, etwa über den „Austragen“-Link im Newsletter. Die
        Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf
        unberührt.</p>
      <p>Bestätigen Sie Ihre Registrierung per Double-Opt-In nicht, werden Ihre Daten wieder
        gelöscht. Ansonsten werden die von Ihnen zum Zwecke des Erhalts des Newsletters bei uns
        hinterlegten Daten von uns bis zu Ihrer Austragung aus dem Newsletter gespeichert und nach der
        Abbestellung des Newsletters gelöscht. Daten, die zu anderen Zwecken bei uns gespeichert
        wurden bleiben hiervon unberührt. Nach Ihrer Austragung aus der Newsletterverteilerliste wird
        Ihre E-Mail-Adresse bei uns in einer Blacklist gespeichert, um künftige Mailings zu verhindern. Die
        Daten aus der Blacklist werden nur für diesen Zweck verwendet und nicht mit anderen Daten
        zusammengeführt. Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der
        Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern (berechtigtes Interesse im
        Sinne des Art. 6 Abs. 1 S. 1 lit. f DSGVO). Die Speicherung in der Blacklist ist zeitlich nicht
        befristet. Sie können der Speicherung widersprechen, sofern Ihre Interessen unser berechtigtes
        Interesse überwiegen (vgl. Art. 21 DSGVO).</p>
      <h3>4. Nutzung der Plattform und unserer Dienste</h3>
      <p>Für die Nutzung der Plattform auf unserer Website („Plattform“) und der dort zur Verfügung
        stehenden Dienste wird Ihnen in der Regel nach erfolgreicher Registrierung und ggf. Verifizierung
        ein Zugangsrecht zur Plattform eingeräumt, über die Sie Trikots in einer Sammlung anlegen,
        präsentieren, kaufen und bei entsprechender Verifizierung verkaufen können.</p>
      <h3>4.1  Registrierung auf der Website und Abschluss eines kostenlosen
        Nutzervertrags als Regular User / anschließende Profilverwaltung  </h3>
      <p>Für die Nutzung der Plattform als „Regular User" müssen Sie sich einmalig
        kostenlos registrieren, indem Sie ein reguläres oder gewerbliches
        Benutzerkonto eröffnen und uns hierbei folgende Daten übermitteln:</p>
      <ul>
        <li>Vor- und Nachname / Firma,</li>
        <li>E-Mailadresse,</li>
        <li>Benutzername,</li>
        <li>Passwort,</li>
        <li>ggf. Anschrift (im Rahmen der Profilverwaltung),</li>
        <li>ggf. Fotoaufnahme (optional im Rahmen der Profilverwaltung),</li>
        <li>ggf. weitere als gewerblicher Nutzer verpflichtend anzugebende Informationen (insb.
          Impressums-Angaben).</li>
      </ul>
      <p>Sofern Sie als Regular User Trikots zum Verkauf anbieten möchten, werden im
        Rahmen der Zahlungsabwicklung über unseren Zahlungsdienstleister (Stripe)
        ggf. weitere Daten erhoben, insbesondere:  </p>
      <ul>
        <li>Zahlungsinformationen (z. B. Kontonummer für Auszahlungen),</li>
        <li>Daten zu Ihrer Identität (z. B. Geburtsdatum,
          Steueridentifikationsnummer, ggf.
          Unternehmensregistrierungsnummern), soweit gesetzlich oder durch
          den Zahlungsdienstleister erforderlich.  </li>
      </ul>
      <p>
        Diese Daten werden von uns zu folgenden Zwecken erhoben, verarbeitet und
        genutzt:
      </p>
      <ul>
        <li>Bereitstellung des Benutzerkontos mit Zugang zur Plattform als Regular
          User,</li>
        <li>Bereitstellung der Dienste über unsere Plattform, einschließlich des
          Kaufs und Verkaufs von Trikots sowie der Zahlungsabwicklung,  </li>
        <li>
          Kommunikation in Bezug auf erforderliche Informationen oder
          Anfragen zu Ihrem Benutzerkonto oder unseren Diensten auf der
          Plattform.
        </li>
      </ul>
      <p>Rechtsgrundlage hierfür ist Art. 6 Abs. 1 S. 1 lit. b DSGVO, da die Angabe der
        vorgenannten Daten – mit Ausnahme einer Fotoaufnahme – für das Erstellen
        Ihres Benutzerkontos und die Nutzung der Plattformdienste (einschließlich
        Kauf und Verkauf von Trikots) auf Grundlage unserer Allgemeinen
        Nutzungsbedingungen für unsere Plattform <a href="/" target="_blank" rel="noopener noreferrer"> www.kitts.de</a> owie den Log-In
        unerlässlich ist. Ohne die Angabe dieser Daten können wir kein Benutzerkonto
        anlegen bzw. die jeweiligen Dienste nicht bereitstellen. Die Daten werden von
        uns für die Bereitstellung Ihres Benutzerkontos verwendet. Sie werden in
        Ihrem persönlichen zentralen Benutzerkonto gespeichert. Dort können Sie sie
        jederzeit einsehen und ändern. Rechtsgrundlage für den Upload einer
        Fotoaufnahme in Ihrem Benutzerkonto ist Ihre ausdrückliche und freiwillige
        Einwilligung gemäß Art. 6 Abs. 1 S. 1 lit. a DSGVO.</p>


      <h3>4.2 Verifizierung und Abschluss eines erweiterten, gegebenenfalls
        kostenpflichtigen Nutzungsvertrags als Verified User  </h3>
      <p>Um als Verified User auf der Plattform gekennzeichnet zu werden und die
        damit verbundenen zusätzlichen Dienste nutzen zu können – insbesondere die
        Kennzeichnung durch das Verified Badge sowie die damit verbundene
        Bestätigung der Authentizität der angebotenen Trikots – müssen Sie nach
        erfolgreicher Registrierung gemäß Ziff. 4.1 einen erweiterten, gegebenenfalls
        kostenpflichtigen Nutzungsvertrag (Abo) mit uns abschließen. Hierfür müssen
        Sie einen Verifizierungsprozess durchlaufen, durch den wir Ihre Profil-Daten
        und sonstige Angaben sowie die Echtheit resp. die Originalität der Trikots, die
        von Ihnen zum Verkauf angeboten werden, prüfen und sicherstellen (sog.
        „Verified User"). Dabei erfragen wir in der Regel folgende Daten von Ihnen:  </p>
      <ul>
        <li>Daten zu Ihrer Identität (z. B. Sozialversicherungsnummer,
          Steueridentifikationsnummer, Geburtsdatum, ggf.
          Unternehmensregistrierungsnummern),  </li>
        <li>Identifikations-/Ausweisdokumente und Informationen, die auf
          Identifikations-/Ausweisdokumenten enthalten sind,  </li>
        <li>Zahlungsinformationen (z. B. Kontonummer etc.) sowie</li>
        <li>ggf. andere Informationen, die Sie als gewerblicher Verkäufer
          bereitstellen (insb. Impressums-Angaben).</li>
      </ul>
      <p>Rechtsgrundlage hierfür ist Art. 6 Abs. 1 S. 1 lit. b DSGVO, da die Verifizierung
        und der Abschluss eines erweiterten, kostenpflichtigen Nutzungsvertrags für
        die Nutzung der zusätzlichen Rechte und Dienste als Verified User nach der im
        Zeitpunkt des jeweiligen Vertragsschlusses gültigen Leistungs- und
        Preisübersicht unter <a href="/" target="_blank" rel="noopener noreferrer"> https://tinyurl.com/kitts-terms</a> , nsbesondere die
        Kennzeichnung als verifizierter Nutzer durch das Verified Badge sowie die
        Bestätigung der Authentizität der angebotenen Trikots, auf Grundlage unserer
        Allgemeinen Nutzungsbedingungen für unsere Plattform  
        <a href="/p/terms-conditions" target="_blank" rel="noopener noreferrer">www.kitts.de/p/terms-conditions </a>
        unerlässlich ist. Ohne Verifizierung können
        wir den Status als Verified User und die damit verbundenen zusätzlichen
        Dienste nicht gewähren.</p>
      <h3>4.3 Nutzung unserer Dienste</h3>
      <p>Im Rahmen der Nutzung unserer Dienste auf der Plattform verarbeiten wir zudem folgende
        weitere (personenbezogene) Daten, die je nach entsprechender Nutzung eines Dienstes von
        Ihnen auf der Plattform zur Verfügung gestellt/hochgeladen werden oder die wir automatisch bei
        der Nutzung unserer Dienste erheben:</p>
      <h4>4.3.1. Einstellen eines Angebots: </h4>
      <p>Daten zum Angebot, die Sie als Verified User im Hinblick auf das
        zu verkaufende Trikot angeben und hochladen (z.B. Text, Fotoaufnahmen, Metadaten zu
        den Kameraeinstellungen hochgeladener Fotoaufnahmen).</p>
      <h4>4.3.2. Verkauf/Kauf eines Trikots:</h4>
      <p>Daten, die aufgrund einer Transaktion, an der Sie entweder als
        Regular oder Verified User auf Käufer- oder Verkäuferseite beteiligt sind, mit Ihrem
        Benutzerkonto in Zusammenhang stehen, wie z.B. Vor- und Nachname,
        Transaktionsbeträge inkl. Provision, Uhrzeit und Ort von Transaktionen, Zahlungsform,
        Bank-/Kontoinformationen (z.B. Kreditkarten- und Kontonummern),
        Versandinformationen (z.B. Anschrift, Versandnummern und Angaben zur
        Sendungsverfolgung) sowie ggf. weitere Informationen, die Sie als gewerblicher Nutzer
        bereitstellen (müssen).</p>
      <h4>4.3.3. Kommunikation mit anderen Nutzern:</h4>
      <p>Daten, die Sie über unser Kommunikations-Tool in
        Nachrichten mit anderen Nutzern austauschen (z.B. Text, Fotoaufnahmen).</p>
      <h4>4.3.4. Kontaktaufnahme mit/durch uns:</h4>
      <p>Daten, die Sie uns bei Kontaktaufnahme zu uns
        mitteilen und/oder die wir – z.B. im Rahmen der Bearbeitung eines KITTS-Käuferschutz-
        Antrags – erfragen/benötigen (z.B. E-Mailadresse, Telefonnummer, Inhalt der Anfrage,
        inhaltliche Informationen zu einer Transaktion/einem Trikot etc., Metadaten der
        Kontaktaufnahme).</p>
      <h4>4.3.5. Sonstige Nutzung unserer Dienste:</h4>
      <p>Daten, die im Rahmen einer Ihrer sonstigen
        Handlungen bei Nutzung unserer Dienste entstehen und mit Ihrem Benutzerkonto
        verknüpft sind.</p>
      <p id="cookie-policy">Wir verarbeiten diese personenbezogenen Daten, um den mit Ihnen geschlossenen (ggf.
        erweiterten) Nutzungsvertrag zu erfüllen, d.h. insbesondere Ihnen unsere Dienste zur Verfügung
        zu stellen, wie z.B. als Vermittlerin die Durchführung von Transaktionen (Vertragsschluss,
        Bezahlung, Versand, Bearbeitung eines KITTS-Käuferschutz-Antrags etc.) zwischen Verkäufer und
        Käufer auf Grundlage unserer Allgemeinen Nutzungsbedingungen für unsere Plattform
        <a href="/p/terms-conditions" target="_blank" rel="noopener noreferrer">www.kitts.de/p/terms-conditions</a> zu ermöglichen. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 S. 1 lit. b
        DSGVO. Zudem erfolgt die Verarbeitung Ihrer Daten bei Kontaktaufnahme zu uns zwecks
        Erbringung unseres Kundenservices und der Bearbeitung Ihrer Anfrage; Rechtsgrundlage hierfür
        ist Art. 6 Abs. 1 S. lit. f DSGVO.</p>
      <h3>5. Cookies auf der Website</h3>
      <p>Um den Besuch unserer Website attraktiv zu gestalten und die Nutzung bestimmter Funktionen
        zu ermöglichen, verwenden wir auf den verschiedenen Unterseiten unserer Website sog. Cookies.
        Dabei handelt es sich um kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und
        verschiedene Funktionen haben. Cookies richten auf Ihrem Endgerät keinen Schaden an,
        enthalten keine Viren, Trojaner oder sonstige Schadsoftware. In dem Cookie werden
        Informationen abgelegt, die sich jeweils im Zusammenhang mit dem spezifisch eingesetzten
        Endgerät ergeben. Dies bedeutet jedoch nicht, dass wir dadurch unmittelbar Kenntnis von Ihrer
        Identität erhalten. Einige der von uns verwendeten Cookies werden nach Ende der Browser-
        Sitzung, also nach Schließen Ihres Browsers, wieder gelöscht (sog. Sitzungs-Cookies). Andere
        Cookies verbleiben auf Ihrem Endgerät und ermöglichen es uns oder unseren
        Partnerunternehmen (sog. Third-Party-Cookies), Ihren Browser bei Ihrem nächsten Besuch
        wiederzuerkennen (sog. persistente Cookies). Werden Cookies gesetzt, erheben und verarbeiten
        sie im individuellen Umfang bestimmte Nutzerinformationen wie Browser- und Standortdaten
        sowie IP-Adresswerte. Persistente Cookies werden nach einer bestimmten Zeitspanne, die je nach
        Cookie unterschiedlich sein kann, automatisch gelöscht. Zudem gibt es Cookies, die dazu dienen,
        das Nutzerverhalten auszuwerten oder Werbung anzuzeigen (sog. Analyse oder Marketing
        Cookies).</p>
      <p>Wir verwenden sowohl technisch notwendige Cookies als auch Analyse und Marketing Cookies
        auf unserer Website. Diese sind unter dem Button „Cookies“ oder einem entsprechend
        markierten Button unten auf der Website stets über unser Cookie-Consent Tool ersichtlich.</p>
      <h3>5.1 Zweck der Verwendung von Cookies</h3>
      <p>Der Zweck der Verwendung technisch notwendiger Cookies besteht darin, die Funktionsfähigkeit
        und Dienste der Website und Plattform zu gewährleisten sowie den Nutzern die Verwendung der
        Website sowie Plattform zu erleichtern und damit Benutzerfreundlichkeit zu gewährleisten. Dabei
        können einige Funktionen unserer Website und Plattform ohne den Einsatz von Cookies nicht
        angeboten werden.</p>
      <p>Marketing und Analyse Cookies dienen dazu, die statistischen Daten der Websitenutzung zu
        erfassen und sie zwecks Verbesserung des Angebotes analysieren zu können und damit das
        Nutzerverhalten auszuwerten oder Werbung anzuzeigen.</p>
      <h3>5.2 Rechtsgrundlage für den Einsatz von Cookies</h3>
      <p>Im Hinblick auf funktionale bzw. technisch notwendige Cookies ist die Rechtsgrundlage unser
        berechtigtes Interesse an den vorstehend genannten Faktoren gemäß Art. 6 Abs. 1 lit. f DSGVO.
        Wir haben ein berechtigtes Interesse an der Speicherung von Cookies zur technisch fehlerfreien
        und optimierten Bereitstellung unserer Dienste.</p>
      <p>Marketing und Analyse Cookies werden von uns nur gesetzt, wenn wir zuvor Ihrer Einwilligung
        eingeholt haben. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. a DSGVO.</p>
      <h3>5.3 Dauer des Einsatzes von Cookies</h3>
      <p>Cookies werden auf Ihrem Endgerät gespeichert und von diesem an unsere Website übermittelt.
        Daher haben Sie als Nutzer auch die volle Kontrolle über die Verwendung von Cookies. Die
        Speicherung unserer Cookies erfolgt bis zur Löschung in Ihrem Browser oder, wenn es sich um
        einen Sitzungs-Cookie handelt, bis die Session abgelaufen ist. Durch Änderung der Einstellungen
        in Ihrem Internetbrowser können Sie die Übertragung von Cookies deaktivieren oder
        einschränken. Bereits gespeicherte Cookies können jederzeit gelöscht werden. Dies kann auch
        automatisch geschehen. Werden Cookies für unsere Website deaktiviert, können unter
        Umständen nicht mehr alle Funktionen der Website in vollem Umfang genutzt werden. Über die
        folgenden Links können Sie sich über diese Möglichkeit für die am meisten verwendeten Browser
        informieren:</p>
      <ul>
        <li>Microsoft Internet-Explorer: https://support.microsoft.com/de-de/help/17442/windows-
          internet-explorer-delete-manage-cookies</li>
        <li>Mozilla Firefox: https://support.mozilla.org/de/kb/Cookies-blockieren</li>
        <li>Google Chrome: https://support.google.com/chrome/answer/95647?
          co=GENIE.Platform%3DDesktop&hl=de</li>
        <li>Safari: https://help.apple.com/safari/mac/8.0/de.lproj/sfri11471.html</li>
      </ul>
      <h3>5.4 Cookie Consent-Tool</h3>
      <p>Wir setzen ein Einwilligungs-Management-Tool ein, um Einwilligungen für die Datenverarbeitung
        bzw. den Einsatz von Cookies oder vergleichbaren Funktionen abzufragen (Pop-up, sofern Sie
        unsere Website besuchen). Sie haben mithilfe des Einwilligungs-Management-Tools die
        Möglichkeit, Ihr Einverständnis für bestimmte Funktionalitäten unserer Website, z.B. zum Zwecke
        der Einbindung externer Elemente, statistischen Analyse, Reichweitenmessung und
        personalisierten Werbung zu erteilen oder abzulehnen. Sie können mithilfe des Einwilligungs-
        Management-Tools Ihre Zustimmung für sämtliche Funktionen erteilen oder ablehnen oder ihre
        Einwilligung für einzelne Zwecke oder einzelne Funktionen erteilen. Die von Ihnen
        vorgenommenen Einstellungen können auch im Nachhinein von Ihnen geändert oder die
        Einwilligungen gänzlich widerrufen werden. Zweck der Einbindung des Einwilligungs-
        Management-Tools ist es, den Nutzern unserer Website die Entscheidung über die vorgenannten
        Dinge zu überlassen und im Rahmen der weiteren Nutzung unserer Website die Möglichkeit zu
        bieten, bereits vorgenommene Einstellungen zu ändern.</p>
      <p>Im Zuge der Nutzung der Einwilligungs-Management-Tools über die Website werden folgende
        personenbezogene Daten an die jeweiligen vorstehend genannten Anbieter übertragen:</p>
      <ul>
        <li>Ihre Einwilligung(en) bzw. der Widerruf Ihrer Einwilligung(en)</li>
        <li>Ihre IP-Adresse</li>
        <li>Informationen über Ihren Browser</li>
        <li>Informationen über Ihr Endgerät</li>
        <li>Zeitpunkt Ihres Besuchs auf der Website</li>
      </ul>
      <p>Rechtsgrundlage für den Einsatz des Einwilligungs-Management-Tools ist Art. 6 Abs. 1 lit. c
        DSGVO, da dadurch die gesetzlich vorgeschriebenen Einwilligungen für den Einsatz bestimmter
        Technologien eingeholt werden.</p>
      <h3>5.5 Cookies, die verarbeitet werden, wenn Sie uns Ihre Einwilligung erteilen</h3>
      <p>Eine Übersicht der von uns verwendeten Cookies, Informationen zu diesen sowie
        Einstellungsmöglichkeiten finden Sie in der Aufstellung des Einwilligungs-Management-Tools.</p>
      <p>Dort können sie einsehen, ob es sich um ein First-Party-Cookie (von unserem Server ausgespielt)
        oder Third-Party-Cookie (vom Server eines Dritten oder Auftragsverarbeiters ausgespielt) handelt.
        Weitere Informationen zur Datenverarbeitung durch Dritte beim Setzen von Cookies (Third-Party-
        Cookies) finden Sie in den Datenschutzhinweisen der jeweiligen Anbieter, die in den Angaben im
        Einwilligungs-Management-Tool verlinkt sind.</p>
      <p>Sie können die Cookie-Einstellungen jederzeit durch einen Klick auf „Cookies“ respektive den
        entsprechenden Button unten auf unserer Website ändern.</p>
      <h3>6. Übermittlung von Daten</h3>
      <p>Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden
        aufgeführten Zwecken findet nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte weiter,
        wenn:</p>
      <ul>
        <li>Sie Ihre nach Art. 6 Abs. 1 lit. a DSGVO ausdrückliche Einwilligung dazu erteilt haben,</li>
        <li>dies gesetzlich zulässig und nach Art. 6 Abs. 1 lit. b DSGVO für die Abwicklung von
          Vertragsverhältnissen mit Ihnen erforderlich ist,</li>
        <li>für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 lit. c DSGVO eine gesetzliche
          Verpflichtung besteht,</li>
        <li>die Weitergabe nach Art. 6 Abs. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder
          Verteidigung von Rechtsansprüchen erforderlich ist und kein Grund zur Annahme
          besteht, dass Sie ein überwiegendes schutzwürdiges Interesse an der Nichtweitergabe
          Ihrer Daten haben oder</li>
        <li>diese an einen in unserem Auftrag und auf unsere ausschließliche Weisung tätigen
          Dienstleister erfolgt, den wir sorgfältig ausgewählt haben (Art. 28 Abs. 1 DSGVO) und mit
          dem wir einen entsprechenden Vertrag über die Auftragsverarbeitung (Art. 28 Abs. 3
          DSGVO) geschlossen haben, der unseren Auftragnehmer u.a. zur Umsetzung
          angemessener Sicherheitsmaßnahmen verpflichtet und uns umfassende
          Kontrollbefugnisse einräumt.</li>
      </ul>
      <p>Einige Ihrer Daten (z.B. Benutzername, ggf. Angebote mit Fotoaufnahmen) sind auf der Plattform
        generell zur Durchführung des (ggf. erweiterten) Nutzungsvertrags mit Ihnen für andere Nutzer
        öffentlich einsehbar.</p>
      <p>Eine Übermittlung an Dienstleister gemäß Buchstabe e) zum Zwecke der Auftragsverarbeitung
        erfolgt in folgenden Bereichen: technische Bereitstellung und Programmierung der Website und
        Plattform, Nutzerkommunikation, Authentifizierung/Echtheitsprüfung, Bezahlung, Versand,
        Bereitstellung von Software als Dienstleistung, Cookie-Consent-Tool.</p>
      <p>Sofern wir Daten in einem Drittland (d.h. außerhalb der Europäischen Union (EU) oder des
        Europäischen Wirtschaftsraums (EWR) verarbeiten oder dies im Rahmen der Inanspruchnahme
        von Diensten Dritter oder bei Offenlegung, bzw. Übermittlung von Daten an Dritte geschieht,
        erfolgt dies nur, sofern eine der vorstehend genannten Rechtsgrundlagen vorliegt sowie die
        besonderen Voraussetzungen der Art. 44 ff. DSGVO sichergestellt sind. D.h. die Verarbeitung
        erfolgt z.B. auf Grundlage eines Angemessenheitsbeschlusses nach Art. 45 DSGVO und/oder
        besonderer Garantien, wie der Beachtung offiziell anerkannter vertraglicher Verpflichtungen
        gemäß Art. 46 Abs. 2 lit. c DSGVO (sog. „EU-Standardvertragsklauseln“ nach dem
        Durchführungsbeschluss der Europäischen Kommission (EU) 2021/914 vom 4. Juni 2021).</p>
      <h3>7. Betroffenenrechte und Beschwerderecht</h3>
      <p>Als Betroffener einer Verarbeitung personenbezogener Daten haben Sie das Recht,</p>
      <ul>
        <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen
          Daten zu verlangen. Insbesondere können Sie Auskunft über die Verarbeitungszwecke,
          die Kategorie der personenbezogenen Daten, die Kategorien von Empfängern,
          gegenüber denen Ihre Daten offengelegt wurden oder werden, die geplante
          Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung
          der Verarbeitung oder Widerspruch, das Bestehen eines Beschwerderechts, die Herkunft
          ihrer Daten, sofern diese nicht bei uns erhoben wurden, sowie über das Bestehen einer
          automatisierten Entscheidungsfindung einschließlich Profiling und ggf. aussagekräftigen
          Informationen zu deren Einzelheiten verlangen;</li>
        <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung
          Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen;</li>
        <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen
          Daten zu verlangen, soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie
          Meinungsäußerung und Information, zur Erfüllung einer rechtlichen Verpflichtung, aus
          Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder
          Verteidigung von Rechtsansprüchen erforderlich ist;</li>
        <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen
          Daten zu verlangen, soweit die Richtigkeit der Daten von Ihnen bestritten wird, die
          Verarbeitung unrechtmäßig ist, Sie aber deren Löschung ablehnen und wir die Daten
          nicht mehr benötigen, Sie jedoch diese zur Geltendmachung, Ausübung oder
          Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO
          Widerspruch gegen die Verarbeitung eingelegt haben;</li>
        <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in
          einem strukturierten, gängigen und maschinenlesebaren Format zu erhalten oder die
          Übermittlung an einen anderen Verantwortlichen zu verlangen und</li>
        <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren. In der Regel
          können Sie sich hierfür an die Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder
          Arbeitsplatzes oder unseres Geschäftssitzes wenden.</li>
      </ul>
      <p>Die für unseren Geschäftssitz zuständige Aufsichtsbehörde ist der</p>
      <p><b>Landesbeauftragte für den Datenschutz und die Informationsfreiheit Rheinland-
        Pfalz</b></p>
      <p>Hintere Bleiche 34 <br />
        D-55116 Mainz</p>
      <p>
        Postfach: 30 40, 55020 Mainz <br />
        Telefon: +49 (0) 6131 8920-0 <br />
        Telefax: +49 (0) 6131 8920-299 <br />
        E-Mail: poststelle@datenschutz.rlp.de <br />
      </p>
      <p>Zur Geltendmachung Ihrer Betroffenenrechte mit Ausnahme des Beschwerderechts bei der
        Aufsichtsbehörde genügt eine E-Mail an info@kitts.de</p>
      <h3>8. Widerrufsrecht bei Verarbeitung aufgrund einer Einwilligung</h3>
      <p>Sofern Ihre personenbezogenen Daten auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a
        DSGVO verarbeitet werden, haben Sie das jederzeitige Recht Ihre Einwilligung ohne Angabe von
        Gründen zu widerrufen. Dies hat zur Folge, dass wir die Datenverarbeitung, die auf dieser
        Einwilligung beruhte, für die Zukunft nicht mehr fortführen dürfen. Durch den Widerruf Ihrer
        Einwilligung wird die Rechtmäßigkeit, der aufgrund der Einwilligung bis zum Widerruf erfolgten
        Verarbeitung allerdings nicht berührt.
        Möchten Sie von Ihrem Widerrufsrecht Gebrauch machen, genügt eine E-Mail an info@kitts.de</p>
      <h3>9. Widerspruchsrecht</h3>
      <p>Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6
        Abs. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch
        gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen, soweit dafür Gründe
        vorliegen, die sich aus Ihrer besonderen Situation ergeben. Richtet sich Ihr Widerspruch gegen
        Direktwerbung haben Sie ein generelles Widerspruchsrecht; eine Begründung ist für diese Fälle
        nicht erforderlich.
        Möchten Sie von Ihrem Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an
        info@kitts.de</p>
      <h3>10. Datensicherheit</h3>
      <p>Wir bedienen uns geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre
        Daten gegen zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust,
        Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere
        Sicherheitsmaßnahmen passen wir entsprechend der technologischen Entwicklung fortlaufend
        an. Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket
        Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser
        unterstützt wird. In der Regel handelt es sich dabei um eine 256 Bit Verschlüsselung. Falls Ihr
        Browser keine 256-Bit Verschlüsselung unterstützt, greifen wir stattdessen auf 128-Bit v3
        Technologie zurück. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt übertragen
        wird, erkennen Sie an der geschlossenen Darstellung des Schüssel- beziehungsweise Schloss-
        Symbols in der unteren Statusleiste Ihres Browsers.
        Allerdings weisen wir darauf hin, dass die Datenübertragung im Internet (z.B. bei der
        Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten
        vor dem Zugriff durch Dritte ist nicht möglich.</p>
      <h3>11. Aktualität und Änderung dieser Datenschutzerklärung</h3>
      <p>Diese Datenschutzerklärung hat den Stand Oktober 2025. Durch die Weiterentwicklung unserer
        Website und unserer Dienste oder aufgrund geänderter gesetzlicher beziehungsweise
        behördlicher Vorgaben, kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die
        jeweils aktuelle Datenschutzerklärung kann jederzeit unter <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">http://www.kitts.de/privacy-policy</a> von
        Ihnen abgerufen und ausgedruckt werden.</p>
      <p>Stand: Oktober 2025</p>
    </div>
  );
};

export default PrivacyPolicy;
